import {
    DialogContent,
    DialogTitle,
    Dialog as MUIDialog,
    DialogActions as MUIDialogActions,
    styled,
} from '@mui/material';
import { forwardRef } from 'react';
import Box from 'shell/components/Box';

const CustomDialog = styled(MUIDialog)(() => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
    },
}));

const DialogActions = styled(MUIDialogActions)(({ theme }) => {
    return {
        padding: theme.spacing(3, 7),
    };
});

const CustomBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(7),
}));

const Dialog = forwardRef(({ children, scroll, ...rest }, ref) => {
    return (
        <CustomDialog ref={ref} role={'main'} {...rest}>
            {scroll ? children : <CustomBox>{children}</CustomBox>}
        </CustomDialog>
    );
});

export { Dialog, DialogActions, DialogContent, DialogTitle };
